import { render } from "./dialog.vue?vue&type=template&id=763b8ffc&scoped=true"
import script from "./dialog.vue?vue&type=script&lang=js"
export * from "./dialog.vue?vue&type=script&lang=js"

import "./dialog.vue?vue&type=style&index=0&id=763b8ffc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-763b8ffc"]])

export default __exports__